/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./AboutSection.css";
import { FaCertificate, FaUsers } from "react-icons/fa";
import aboutImg from "../Image/serviceset/iStockHousekeeping.jpg";

export default function AboutSection() {
  return (
    <section className="densat-about-v2-section">
      <div className="densat-about-v2-container">

        {/* LEFT – IMAGE */}
        <div className="densat-about-v2-left">
          <div className="densat-about-v2-image-wrap">
            <img
              src={aboutImg}
              alt="Densat Facility Management Services"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="densat-about-v2-right">
          <span className="densat-about-v2-tag">
            Integrated Facility Management
          </span>

          <h3 className="densat-about-v2-title">
            Housekeeping Services Across <br /> 15 Cities in India
          </h3>

          <p className="densat-about-v2-text">
            Densat FM Services Pvt. Ltd. delivers end-to-end facility management,
            housekeeping, technical maintenance, pantry operations, guest-house
            management, and specialised cleaning services across major Indian
            cities .
          </p>

          <p className="densat-about-v2-text">
            We combine trained manpower, efficient processes, and full statutory
            compliance to help organisations maintain world-class environments.
          </p>

          {/* FEATURES */}
          <div className="densat-about-v2-features">
            <div className="densat-about-v2-feature-card">
              <FaCertificate />
              <h4>Certified Excellence</h4>
            </div>

            <div className="densat-about-v2-feature-card">
              <FaUsers />
              <h4>Expert Team</h4>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
